import { FormatterService } from "@/domain/services";
import moment, { unitOfTime } from "moment";

export class TimeFormatter implements FormatterService {
  format(value: number, unit: unitOfTime.Base): string {
    const duration = moment.duration(value, unit);
    const hours = duration.hours().toString().padStart(2, "0");
    const minutes = duration.minutes().toString().padStart(2, "0");
    const seconds = duration.seconds().toString().padStart(2, "0");

    if (Number(hours) > 0) {
      return `${hours}:${minutes}:${seconds}`;
    }
    return `${minutes}:${seconds}`;
  }
}
